/**
 * @module interface
 */
export interface V2TimCustomElem {
    data?: string;
    desc?: string;
    extension?: string;
}
